import React from 'react';
import tick_icon from './images/tick-icon.png';
import business_women_img from './images/Business-woman-girl.png';
import ScrollAnimation from 'react-animate-on-scroll';


export default function Mainland() {

    return (
        <>

            <div className='container-fluid bg-img-mainland main-mainland' id='mainland'>
                <section className="mx-auto max-w-screen-xl pb-12 px-4 items-center lg:flex md:px-8">
                    <div className="space-y-4 flex-1 sm:text-center lg:text-left">
                        <ScrollAnimation animateIn="fadeIn">
                            <h1 className="text-white font-bold text-4xl">
                                Establish Your Business<br></br> <span style={{ color: "#1fa1cb" }}>On The Mainland</span>
                            </h1>
                            <p className="text-white max-w-xl leading-relaxed sm:mx-auto lg:ml-0">
                                Explore limitless possibilities with Dubai Setup expert guidance in Mainland company formation in Dubai.
                            </p>
                        </ScrollAnimation>
                    </div>
                    {/* <div className="flex-1 text-center  lg:mt-0 lg:ml-3" style={{ marginTop: -100 }}>
                        <img src={side_img} className=" mx-auto sm:w-9/12 " />
                    </div> */}
                </section>
            </div>

            <section className="py-14">
                <div className="max-w-screen-xl mx-auto md:px-8">
                    <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
                        <div className="flex-1 sm:hidden lg:block">
                            <ScrollAnimation animateIn="fadeIn">
                                <img src="https://alhadifsetup.com/blog/assets/img/top-areas-to-setup-your-business-in-dubai.jpg" className="md:max-w-lg sm:rounded-lg" alt="" />
                            </ScrollAnimation>
                        </div>
                        <div className="max-w-xl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xl">
                            <ScrollAnimation animateIn="fadeIn">
                                <p className="text-gray-600 text-3xl font-bold sm:text-3xl">
                                    Why Should You Set Up Your <span style={{ color: "#1fa1cb" }}>Business on the Mainland?</span>
                                </p>
                                <p className="mt-3  text-gray-500 font-small">
                                    The reasons can be many. All we can tell you is that there is a best-fit for every business, and your business could potentially benefit from having an office in the mainland of the United Arab Emirates, as opposed to setting it up in a designated free zone or as an offshore company.
                                    <br></br>
                                    If you are an advertising company, your clients will definitely appreciate being able to reach you in an easy-to-access location. It is much easier than travelling to a free zone on the outskirts of the city, plus you can scale up more easily as you grow. Some legal advisory firms pay a lot of attention to the privacy of their clients, and having an office on the mainland enables them to achieve this objective. There are just a few examples of the advantages of locating your <span style={{ fontWeight: 'bold' }}>business on the mainland.</span>
                                </p>
                            </ScrollAnimation>

                        </div>
                    </div>
                </div>
            </section>

            <section className="py-2 mt-5">
                <div className="max-w-screen-xl mx-auto px-4  gap-x-12 justify-between md:flex md:px-8">
                    <div className="max-w-xxl">
                        <ScrollAnimation animateIn="fadeIn">
                            <h3 className="text-gray-600 text-3xl font-bold sm:text-3xl pb-1">
                                How to Establish Your Company on the Mainland
                            </h3>
                        </ScrollAnimation>
                        <p className="mt-5 text-gray-500 font-medium">
                            The first step involves identifying what the commercial activities you plan to undertake are. Based on this, the right company structure that is beneficial for your business can be determined. For instance, you could set up your company as a Sole Establishment, a Legally Limited Partnership, a Legally Limited Company, or a Private Limited Company.
                        </p>
                        <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            Registering a company on the mainland requires you to have a Local Sponsor who will own 51% of the company. The <span style={{ fontWeight: 'bold', color: '#1fa1cb' }}>Local Sponsor</span> can be a male or female above the age of 21. In addition, the Local Sponsor must be a UAE national or an Emirati.
                        </p>
                        <p className="mt-5 text-gray-500 font-normal pb-5" style={{ lineHeight: 2, fontStyle: 'italic' }}>
                            Having a Local Sponsor who owns 51% of your company does not mean the Local Sponsor takes home 51% of the profits. Things work differently in the UAE. The Local Sponsor needs to be paid a Sponsor Fee according to a predetermined agreement, and this could be done on a monthly / quarterly / half-yearly / annual basis. In some cases, the Local Sponsor takes a percentage of the sales.
                        </p>
                        <p className="mt-2 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            The Local Sponsor is legally responsible for the functioning of your company. But the Local Sponsor can sign over a Power of Attorney relinquishing his/her control over your company, and this way, you will in charge of everything.
                        </p>
                        <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            The Local Sponsor can be an individual, or it could also be another company incorporated in the United Arab Emirates. The latter still functions in the same way, putting you in full control over your business.
                        </p>
                        <ScrollAnimation animateIn="fadeIn">
                            <h3 className=" text-gray-600 text-3xl font-bold sm:text-3xl mt-5 pb-3">
                                Need the Help of a Professional Company Setup Specialist?
                            </h3>
                        </ScrollAnimation>
                        <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            This is where we come into the picture. At Dubai Setup, we have a track record of matching companies with the right Local Partner. Our <span style={{ fontWeight: 'bold', color: '#1fa1cb' }}>business setup </span>experts are all informed of the latest changes in legislation and can tell you that if you are a professional planning to offer professional services*, then what you need is a Local Service Agent and not a Local Partner.
                        </p>
                        <p className="mt-5 text-gray-500 font-normal pb-5" style={{ lineHeight: 2, fontStyle: 'italic' }}>
                            *Examples include a doctor planning to open his/her consulting clinic, a lawyer planning to open his legal consulting firm, an engineer planning to offer engineering consultancy services and so forth.
                        </p>
                        <p className=" text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            A <span style={{ fontWeight: 'bold', color: '#1fa1cb' }}>Local Service Agent,</span> unlike a Local Partner, does not own 51% of your company. He/She is still legally responsible for your business and will represent you in all Government-related matters, including when it comes to getting a Business License.
                        </p>
                        <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            Our team also consists of legal professionals who will go the extra mile to ensure that everything is above board and in order. We also have expert auditors who can take care of the annual audit, which is mandatory for companies established on the mainland.
                        </p>
                    </div>
                </div>
            </section>


            <div className='container-fluid bg-img-mainland-2 ' style={{ marginTop: 100 }}>
                <section className="mx-auto max-w-screen-xl px-4 items-center lg:flex md:px-8">
                    <div className="space-y-4 flex-1 sm:text-center lg:text-left">
                        <ScrollAnimation animateIn="fadeIn">
                            <h1 className="text-white font-bold text-4xl">
                                Mainland  <br></br> <span style={{ color: "#1fa1cb" }}>Company Setup</span>
                            </h1>
                        </ScrollAnimation>
                    </div>
                    <div className="flex-1 text-center  lg:mt-0 lg:ml-3" style={{ marginTop: -100 }}>
                        <img src={business_women_img} className=" mx-auto sm:w-9/12 " />
                    </div>
                </section>
            </div>

            <section className="py-2 mt-5 mb-5" style={{ marginTop: 50 }}>
                <div className="max-w-screen-xl mx-auto px-4">
                    <h3 className="text-gray-600 text-2xl font-bold sm:text-3xl pb-1">
                        Benefits of Setting Up a Company on the Mainland
                    </h3>

                    <div className='row' style={{ marginTop: 70 }}>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Benefits of Setting Up a Company on the Mainland
                                </h3>
                            </div>
                        </div>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded mb-5"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Unrestricted flexibility to scale up or down, depending on business needs
                                </h3>
                            </div>
                        </div>
                    </div>


                    <div className='row' style={{ marginTop: 20 }}>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Stable business climate and regulatory framework
                                </h3>
                            </div>
                        </div>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded mb-5"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Ability to operate in both local and international markets at the same time
                                </h3>
                            </div>
                        </div>
                    </div>

                    <div className='row' style={{ marginTop: 20 }}>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Access to a truly global pool of talent from around the world
                                </h3>
                            </div>
                        </div>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded mb-5"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Presence of major banks and audit services to fuel your growth.
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className='row' style={{ marginTop: 20 }}>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Freedom to choose the location of your office
                                </h3>
                            </div>
                        </div>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded mb-5"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Ease of doing business, simplified by international conferences and trade expos
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-14 max-w-screen-xl mx-auto ">
                <div className="relative overflow-hidden mx-4 px-4 py-14 rounded-2xl bg-blue-600 md:px-8 md:mx-8 main-contact">
                    <div className="relative z-10 max-w-xxl mx-auto sm:text-center">
                        <div className="space-y-3">
                            <h3 className="text-2xl text-customLightBlue font-bold">
                                Have a question? get in touch with us
                            </h3>
                            <h3 className="text-1xl text-white font-bold" style={{ fontSize: 18 }}>
                                Get started with your business needs, we reach out with free and qualified guidance
                            </h3>
                            <h3 className="text-2xl text-white font-bold">
                                Call us today : +971 56 265 7300
                            </h3>
                        </div>
                    </div>
                    <div className="absolute inset-0 w-full h-full" style={{
                        background: "linear-gradient(268.24deg, rgba(31, 41, 55, 0.84) 50%, rgb(102, 102, 102, 0.79) 80.61%, rgba(55, 48, 163, 0) 117.35%, rgba(169, 169, 169, 0.5))"
                    }}></div>

                </div>
            </section>

            <div className=''>
                <section className="py-14">
                    <div className="max-w-screen-xl mx-auto md:px-8">
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
                            <div className="flex-1 sm:hidden lg:block" style={{ marginBottom: 200 }}>
                                <div className="fb-iframe-container">
                                    <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fweb.facebook.com%2Fdubaisetupinfo.co&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                                        width="1240" height="500" className='fb-frame' style={{ border: 'none', overflow: 'hidden' }} scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                                </div>
                            </div>
                            <div className="max-w-xl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xl">
                                <div className="fb-container-text">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-4xl mb-5">
                                        Dubai Setup  <span className="text-customLightBlue">Facebook Page</span>
                                    </h3>
                                    <p className="text-gray-900 text-1xl font-normal sm:text-1xl ">
                                        This company's Facebook page is a testament to their dedication to excellence, fostering a vibrant community, and showcasing their creativity. With captivating content and interactive engagement, they go beyond mere promotion, building genuine connections with their audience. Each post tells a story, evoking emotions and leaving a lasting impression on followers. Their commitment to innovation shines through in every aspect of their page, setting them apart from the competition. Moreover, they prioritize customer satisfaction, ensuring transparency and authenticity in all interactions. Their page serves as a window into their values and aspirations, inspiring trust and loyalty among their followers. Overall, this company's Facebook presence embodies their passion for making a difference and leaves a lasting impact on all who engage with it.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


        </>
    )
}
